import { useEvaluationResults } from "@/stores/useEvaluationResults";
import { useChecklistControllerStore } from "~/composables/useChecklistControllerStore";

export const useStepResultsStore = (documentId: string) => {
  const { revision } = useSubmittedDocumentStore(documentId);

  if (!revision) {
    throw new Error("Revision is not defined");
  }

  const { currentStep, currentChecklistCriteriaInstance } =
    useChecklistControllerStore(documentId);

  if (!currentStep && !currentChecklistCriteriaInstance) {
    throw new Error("Current step is not defined");
  }

  const checklistCriteriaId =
    currentStep?.checklistCriteriaId ??
    currentChecklistCriteriaInstance?.checklistCriteriaId;
  const checklistSectionId =
    currentStep?.checklistSectionId ??
    currentChecklistCriteriaInstance?.checklistSectionId;

  if (!checklistCriteriaId || !checklistSectionId) {
    throw new Error("Checklist criteria or section is not defined");
  }

  return useEvaluationResults(
    documentId,
    revision.id,
    checklistSectionId,
    checklistCriteriaId,
    (currentStep ?? currentChecklistCriteriaInstance)!
  )();
};
